import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="clickable-card"
export default class extends Controller {
  static targets = [ "link" ]

  visit(event) {
    // Ensure the click didn't happen directly on the link itself
    // or another interactive element within the card if we add more later.
    if (event.target.closest('a, button, input, textarea, select')) {
      return;
    }

    // Check if the specific card clicked has a link target
    if (this.hasLinkTarget) {
      const linkElement = this.linkTarget;
      const url = linkElement.getAttribute('href');
      const target = linkElement.getAttribute('target');

      if (url) {
        if (target === '_blank') {
          window.open(url, '_blank');
        } else {
          // Use Turbo Drive for navigation if available, otherwise fallback
          if (window.Turbo) {
            window.Turbo.visit(url);
          } else {
            window.location.href = url;
          }
        }
      }
    } else {
      debugWarn("Clickable card controller activated on an element without a 'data-clickable-card-target=link'", event.currentTarget);
    }
  }
}
